/** 传染病 */

/** 对应的标题 */
const categoryMap = {
  Candida: '念珠菌感染评分',
  PIROCAP: 'CAP PIRO评分',
  DukeCriteria: 'Duke 诊断标准 （改良版）',
  Peritonitis: '腹膜炎分类（Hinchey）',
  PSS: '腹膜炎严重程度评分',
  qSOFA: 'qSOFA',
  PIROVAP: 'VAPPIRO评分',
  CentorMcIsaac: 'Centor 和 Mclsaasc （评分）',
  CPIS: 'CPIS',
  Jones: 'Jones 诊断标准（修订版）',
  SIRS: 'SIRS 诊断标准',
  ISTH_DIC_non_overt: 'ISTH DIC（非显性）',
  ISTH_DIC_overt: 'ISTH DIC（显性）',
  LRINEC: 'LRINEC 评分',
  Sepsis3: '脓毒性休克',
  Marshall: 'Marshall 评分系统',
  AbsoluteNeutrophilCount: '中性粒细胞绝对计数',
  Procalcitonin:'降钙素原（PCT）',
  Anti_Streptolysin_O:'抗链球菌溶血素O（ASO）',
  Lymphocyte:"淋巴细胞（LYMPH）",
  Lymphocyte_Absolute_Count:'淋巴细胞（淋巴细胞绝对计数）',
  

}
/** 对应的描述 */
const categoryDescMap = {
  PIROCAP: '社区获得性肺炎死亡率',
  DukeCriteria: '感染性心内膜炎的诊断标准',
  Peritonitis: '肠穿孔的分类',
  PSS: '腹膜炎死亡风险',
  PIROVAP: '呼吸机相关性肺炎死亡率',
  CentorMcIsaac: '链球菌感染所致咽炎？',
  CPIS: '临床肺部感染评分',
  Jones: '急性风湿热的诊断',
  SIRS: '脓毒症诊断你的第一步',
  ISTH_DIC_non_overt: '非显性弥散性血管内凝血',
  ISTH_DIC_overt: '显性弥散性血管内凝血',
  LRINEC: '坏死性筋膜炎风险',
  Marshall: '急性胰腺炎患者器官衰竭',
  AbsoluteNeutrophilCount: '是否存在中性粒细胞减少？'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/ID.js